(() => {
  const dialog = document.getElementById('km-newsletter-popup');
  if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
  if (/\/(?:cart|checkout|checkouts|account|customers)(?:\/|$)/i.test(window.location.pathname)) return;
  const prefix = 'km-newsletter-v2:';
  const dismissKey = `${prefix}dismissed-until`;
  const sessionKey = `${prefix}shown`;
  const subscribedKey = `${prefix}subscribed`;
  const read = (storage, key) => {
    try { return window[storage].getItem(key); } catch (_) { return null; }
  };
  const write = (storage, key, value) => {
    try { window[storage].setItem(key, value); } catch (_) { }
  };
  const suppressed = () => read('sessionStorage', sessionKey) === '1'
    || Number(read('localStorage', dismissKey)) > Date.now()
    || read('localStorage', subscribedKey) === '1';
  if (suppressed()) return;
  let previousFocus = null;
  let previousOverflow = '';
  let opened = false;
  const close = () => {
    if (dialog.open) dialog.close();
  };
  dialog.querySelectorAll('[data-km-newsletter-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button, a[href], iframe, input, select, textarea, [tabindex="0"]')].filter(control => !control.disabled && control.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    if (!opened) return;
    document.body.style.overflow = previousOverflow;
    write('localStorage', dismissKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
    if (previousFocus?.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  });
  const busy = () => {
    if (document.hidden || document.querySelector('dialog[open], details[open] summary, .menu-opening')) return true;
    const active = document.activeElement;
    if (active && active.matches('input, textarea, select, iframe, [contenteditable="true"]')) return true;
    const footer = document.querySelector('.km-newsletter--footer');
    if (!footer) return false;
    const rect = footer.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };
  const maybeOpen = () => {
    if (suppressed() || opened) return;
    if (busy()) {
      window.setTimeout(maybeOpen, 10000);
      return;
    }
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    try {
      dialog.showModal();
    } catch (_) {
      return;
    }
    opened = true;
    document.body.style.overflow = 'hidden';
    write('sessionStorage', sessionKey, '1');
  };
  window.setTimeout(maybeOpen, window.matchMedia('(max-width: 749px)').matches ? 20000 : 12000);
})();
